import { FC, useCallback } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import DeleteIcon from '@mui/icons-material/Delete';
import TableRow from '@mui/material/TableRow';
import TableCell from 'components/TableCell';
import ConfirmableIconButton from 'components/ConfirmableIconButton';

import { HotelEditRoomsRow_room$key } from '__generated__/HotelEditRoomsRow_room.graphql';
import Link from '@mui/material/Link';

type Props = {
  room: HotelEditRoomsRow_room$key;
  onDelete: (id: string) => void;
};

const HotelEditRoomsRow: FC<Props> = props => {
  const { onDelete } = props;

  const { id, nameString, capacity } = useFragment(
    graphql`
      fragment HotelEditRoomsRow_room on Room {
        id
        nameString
        capacity
      }
    `,
    props.room
  );

  const handleDeleteClick = useCallback(() => {
    onDelete(id);
  }, [id, onDelete]);

  return (
    <TableRow>
      <TableCell>
        <Link href={`/rooms/${id}`}>{nameString}</Link>
      </TableCell>

      <TableCell center>{capacity}</TableCell>

      <TableCell center>
        <ConfirmableIconButton onConfirm={handleDeleteClick}>
          <DeleteIcon fontSize="small" />
        </ConfirmableIconButton>
      </TableCell>
    </TableRow>
  );
};

export default HotelEditRoomsRow;
